import { TOAST_DEFAULT_DURATION_MS, useToast } from '@/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function (toast) {
        const { id, title, description, action, duration, ...props } = toast;
        return (
          <Toast
            key={id}
            {...props}
            duration={duration ?? TOAST_DEFAULT_DURATION_MS}
            onOpenChange={open => {
              if (!open) {
                dismiss(id);
              }
            }}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
